import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Leaf, ShieldCheck, Sparkles, Droplets } from "lucide-react";

const features = [
  { icon: Droplets, key: "freshness" },
  { icon: ShieldCheck, key: "halal" },
  { icon: Sparkles, key: "quality" },
  { icon: Leaf, key: "hygiene" },
];

export default function Intro() {
  const { t } = useLanguage();

  return (
    <section id="intro" data-testid="intro-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            data-testid="intro-title"
            className="font-heading text-3xl lg:text-4xl font-semibold tracking-tight mb-6"
            style={{ color: "#0A0A0A" }}
          >
            {t("intro.title")}
          </h2>
          <div className="w-16 h-0.5 mx-auto mb-6" style={{ backgroundColor: "#D4AF37" }} />
          <p className="text-base leading-relaxed text-neutral-600 max-w-3xl mx-auto">
            {t("intro.text")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map(({ icon: Icon, key }) => (
            <div
              key={key}
              data-testid={`intro-feature-${key}`}
              className="text-center p-8 bg-[#F9F9F9] rounded-sm hover:shadow-md transition-shadow"
            >
              <div
                className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full"
                style={{ backgroundColor: "#8B0000" }}
              >
                <Icon className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-heading font-semibold text-lg mb-2" style={{ color: "#0A0A0A" }}>
                {t(`intro.${key}`)}
              </h3>
              <p className="text-sm text-neutral-500 leading-relaxed">
                {t(`intro.${key}Desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
